<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h4 class="card-title">
          Client List
        </h4>
      </div>
      <div class="card-body">
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="20%">Name</th>
              <th width="15%">Address</th>
              <th width="6%">CNIC/Passport No</th>
              <th width="10%">CNIC/Passport Issueance Date</th>
              <th width="10%">CNIC/Passport Expiry Date</th>
              <th width="10%">PEP Yes/No</th>
              <th width="10%">If yes,Self Position</th>
              <th width="10%">Association/Relationship with PEP</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,ind) in list" :key="ind">
              <td>{{item.BP_DSC}}</td>
              <td>{{item.PTR_TYPE}}</td>
              <td>{{item.City}}</td>
              <td>{{item.BN_DESC}}</td>
              <td>{{item.BP_MOBILE}}</td>
              <td>{{item.BP_GST_NO}}</td>
              <td>{{item.BP_NIC_NO}}</td>
              <td>{{item.BP_NTN_NO}}</td>
              <td>
                <button class="btn btn-primary btn-sm" @click="editInsured(item.BP_ID)">Edit</button>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default ({
    data() {
      return {
        list: [],
      }
    },
    updated() {
      $("#myTable").DataTable();
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/pageLoadAdvClientList")
          .then(function (res) {
            endReq();
            vm.list = res.data.list;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      editInsured(id) {
        window.open("/UIC/AdvanceClientProfile?id=" + id);
      },
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/ims/AdvanceClientProfileList.vue